import { parseJwt } from 'cu-master-layout-prop-manager';

import { SYSTEM_ROLE_NAMES } from '@/constants';

export const getUserRole = (token: string): (typeof SYSTEM_ROLE_NAMES)[keyof typeof SYSTEM_ROLE_NAMES] | null => {
  const parsedToken = parseJwt(token) as unknown as Record<string, string>;

  return parsedToken ? (parsedToken['role'] as (typeof SYSTEM_ROLE_NAMES)[keyof typeof SYSTEM_ROLE_NAMES]) : null;
};
